import { axiosInstance } from "./axiosInstance";

export class RoleService {
    async getRoleData(roleId: number) {
        const response = await axiosInstance.get(`/roles/${roleId}`);
        return response;
    }

    async updateActiveRole(userId: number, roleId: number) {
        const response = await axiosInstance.put(`/roles/${roleId}/_update`, { userId });
        return response;
    }
}